import ApiClient from '@/api/ApiClient';
import BaseService from './BaseService';
import Testimony from '@/api/models/Testimony';

class TestimonyService extends BaseService {
    #prefixUrl = 'api/testimonies/';

    STORAGE_DEFINITION = {
        TESTIMONIES_LIST: 'testimoniesList'
    };

    constructor() {
        super();
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Get all testimonies
     * @returns {Array}
     */
    async get() {
        let testimonies = this.getArrayOnStorage(this.STORAGE_DEFINITION.TESTIMONIES_LIST);

        if (testimonies.length == 0) {
            const response = await this.api.executeRequest(`/`, {}, this.api.methods.GET);

            if (response.success() && response.getContent() != null) {
                for (let testimonyData of response.getContent()) {
                    testimonies.push(new Testimony(testimonyData));
                }

                this.saveArrayOnStorage(this.STORAGE_DEFINITION.TESTIMONIES_LIST, testimonies);
                
            } else {
                this.saveArrayOnStorage(this.STORAGE_DEFINITION.TESTIMONIES_LIST, []);
            }
        }

        return testimonies;
    }

    /**
     * Saves testimonies by creating or updating
     * @param {Array} testimonies
     * @returns {api/models/Response}
     */
    async save(testimonies = []) {
        const response = await this.api.executeRequest('/', { testimonies: testimonies }, this.api.methods.POST);

        if (response.success() && response.getContent() != null) {
            let testimonies = [];

            for (let testimonyData of response.getContent()) {
                testimonies.push(new Testimony(testimonyData));
            }

            response.setContent(testimonies);
            this.saveArrayOnStorage(this.STORAGE_DEFINITION.TESTIMONIES_LIST, testimonies);
        }
        
        return response;
    }
}

export default new TestimonyService();
